var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tax-mask",on:{"click":function($event){$event.stopPropagation();_vm.set_tax_mask_hide($event)},"touchmove":function($event){$event.preventDefault();_vm.event_touchmove($event)}}},[_c('p',{staticClass:"tax-wrapper"},[_vm._v("\n        海外商品税金预计：¥"+_vm._s(_vm.taxStr)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a96ad4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaxMask/index.vue
// module id = null
// module chunks = 